var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-contact",on:{"click":_vm.onClick}},[_c('Gravatar',{attrs:{"email":_vm.email,"default-img":"monsterid"}}),_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }